export const sliceDate = (date) => {
  const slice = date.split(',');
  return slice[0] + ',' + slice[1];
};
